import React from 'react';
import {ContactAndAddressSummary} from '../../../../ContactAndAddressSummary/ContactAndAddressSummary';
import {useControllerProps} from '../../../../Widget/ControllerContext';
import {CustomerDetailsStepDataHook} from '../CustomerDetailsStep';
import {classes} from './CustomerDetailsCollapsed.st.css';

export const CustomerDetailsCollapsed = () => {
  const {
    checkoutStore: {cart, isShippingFlow, extendedFieldsView},
  } = useControllerProps();

  const address = isShippingFlow ? cart.deliveryInfo.address : undefined;

  return (
    <div data-hook={CustomerDetailsStepDataHook.collapsed} className={classes.root}>
      <ContactAndAddressSummary
        contact={cart.deliveryInfo.contact}
        dataExtendedFields={extendedFieldsView}
        email={cart.customerInfo.email}
        customField={cart.customField}
        address={address}
      />
    </div>
  );
};
